import type { CustomHeaderProps } from 'ag-grid-react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

interface DagConditionalHeaderProps extends CustomHeaderProps {
  tooltipText: string
}

export function DagConditionalHeader(props: DagConditionalHeaderProps) {
  const { displayName, tooltipText } = props

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-help truncate">{displayName}</span>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <p className="max-w-xs text-sm">{tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
